document.addEventListener('DOMContentLoaded', function() {
  function labelSwatches() {
    document.querySelectorAll('.bcpo-front-image-option').forEach(function(input) {
      if (input.value && !input.hasAttribute('aria-label')) {
        input.setAttribute('aria-label', input.value);
      }
    });
  }
  labelSwatches();
  var observer = new MutationObserver(labelSwatches);
  observer.observe(document.body, { childList: true, subtree: true });
});